<template>
  <div
    class="fts-event"
    :class="[
      stateIndicator ? event.enabled !== false ? 'event--active' : 'event--disabled' : '',
      {'event--default': !event.description}
    ]"
    @click="open"
    v-if="event"
  >
    <!-- notification icon -->
    <template v-if="event.notification || event.actionType === 'notification'">
      <font-awesome-icon
        :icon="['far', 'envelope']"
        class="event-icon"
        v-if="event.channel == 'email'"
      />
      <font-awesome-icon
        :icon="['far', 'comment']"
        class="event-icon"
        v-else-if="event.channel == 'sms'"
      />
      <font-awesome-icon
        :icon="['fab', 'whatsapp']"
        class="event-icon"
        v-else-if="event.channel == 'whatsapp'"
      />
      <font-awesome-icon
        :icon="['fab', 'slack']"
        class="event-icon"
        v-else-if="event.channel == 'slack'"
      />
      <font-awesome-icon
        :icon="['far', 'bell']"
        class="event-icon"
        v-else
      />
    </template>
    <!-- advanced icon -->
    <font-awesome-icon
      :icon="['fas', 'scroll']"
      class="event-icon"
      v-else-if="event.actionType === 'advanced'"
    />
    <!-- automation icon -->
    <font-awesome-icon
      :icon="['fas', 'bolt']"
      class="event-icon"
      v-else
    />
    <!-- label -->
    <span class="event-label">
      {{eventLabel}}
    </span>
    <!-- count -->
    <div class="event-count" v-if="event.count">
      {{event.count}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: Object,
    stateIndicator: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    open() {
      this.$emit('open', this.event);
    },  
  },
  computed: {
    eventLabel() {
      if (this.event.name)
        return this.event.name;
      else if (this.event.description)
        return this.event.description;
      else if (
        this.event.notification ||
        this.event.actionType === 'notification'
      )
        return 'Notification';
      else if (this.event.actionType === 'advanced')
        return 'Advanced';
      else if (this.event.actionType === 'automation')
        return 'Automation';
      else
        return '(undefined)';
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

@mixin event-state() {
  &::before {
    content: '';
    height: .375rem;
    width: .375rem;
    margin-left: -.125rem;
    margin-right: .375rem;;
    border-radius: 10em;
  }
}
.fts-event {
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 0.125rem 0.375rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  background-color: var(--fts-gray-2);
  color: var(--fts-gray-6);
  font-size: 0.75rem;
  line-height: 1rem;
  cursor: pointer;
  &.event--active {
    @include event-state;
    &::before {
      background-color: var(--fts-success);
    }
  }
  &.event--disabled {
    @include event-state;
    &::before {
      background-color: var(--fts-danger);
    }
  }
  &.event--default {
    .event-label {
      font-style: italic;
    }
  }
  &:hover {
    @include theme() {
      border-color: rgba(theme-get('fts-primary'), .75);
      background-color: rgba(theme-get('fts-primary'), .095);
    }
    color: var(--fts-primary);
    .event-count {
      background-color: var(--fts-primary);
      color: #fff;
    }
  }
  .event-icon {
    margin-right: .25rem;
  }
  .event-label {
    word-break: break-all;
  }
  .event-count {
    @include flex-center-middle;
      min-width: 1rem;
      margin-left: .375rem;
      padding: 0rem .2rem;
      border-radius: .575rem;
      background-color: var(--fts-gray-5);
      color: var(--fts-gray-1);
      font-size: 85%;
  }
}
</style>